import { render, staticRenderFns } from "./BackupView.vue?vue&type=template&id=83d71c9c"
import script from "./BackupView.vue?vue&type=script&lang=js"
export * from "./BackupView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports